import { API_URLS } from '@helpers/api';
import { withMotion } from '@hoc/withMotion';
import { withQueryParams } from '@hoc/withQueryParams';
import LoadingIndicator from '@stories/Components/Misc/LoadingIndicator/LoadingIndicator';
import React from 'react';
import { BookEventFormStyles as S } from './BookEventForm.styles';
import StepOne from './Steps/StepOne/StepOne';
import StepThree from './Steps/StepThree/StepThree';
import StepTwo from './Steps/StepTwo/StepTwo';
const fetchDefaults = {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
    },
};
const BookEventForm = ({ eventId, anchorId, sectionTitle, eventLocationType, title, inPartnershipWith, date, time, venue, bookingForm, failureMessages, bookingFormData, confirmationMessage, confirmationTitle, alternativeContent, }) => {
    const [activeStep, setActiveStep] = React.useState(1);
    const [submitting, setSubmitting] = React.useState(false);
    const [stepOneResponse, setStepOneResponse] = React.useState();
    const [stepTwoResponse, setStepTwoResponse] = React.useState();
    const [stepThreeResponse, setStepThreeResponse] = React.useState();
    React.useEffect(() => {
        if (bookingFormData) {
            setStepOneResponse({
                data: {
                    priceData: bookingFormData.priceData,
                    totalPrice: bookingFormData.totalPrice,
                    totalPriceDiscounted: bookingFormData.totalPriceDiscounted,
                },
            });
            setStepTwoResponse({ data: { attendees: bookingFormData.attendees } });
            setStepThreeResponse({
                data: {
                    priceData: bookingFormData.priceData,
                    totalPrice: bookingFormData.totalPrice,
                    totalPriceDiscounted: bookingFormData.totalPriceDiscounted,
                },
            });
        }
    }, [bookingFormData]);
    const submit = async (data) => {
        setSubmitting(true);
        switch (activeStep) {
            default:
            case 1: {
                const request = {
                    step: 1,
                    eventId: eventId,
                    data: data,
                };
                const response = await fetch(API_URLS.SUBMIT_BOOK_EVENT_STEP1, {
                    ...fetchDefaults,
                    body: JSON.stringify(request),
                }).then((x) => x.json());
                setStepOneResponse(response);
                if (!response.errors || Object.keys(response.errors).length === 0) {
                    setStepThreeResponse(response);
                    setActiveStep(activeStep + 1);
                }
                break;
            }
            case 2: {
                const request = {
                    step: 2,
                    eventId: eventId,
                    data: data,
                };
                const response = await fetch(API_URLS.SUBMIT_BOOK_EVENT_STEP2, {
                    ...fetchDefaults,
                    body: JSON.stringify(request),
                }).then((x) => x.json());
                setStepTwoResponse(response);
                if (!response.errors || Object.keys(response.errors).length === 0) {
                    setActiveStep(activeStep + 1);
                }
                break;
            }
            case 3: {
                const request = {
                    step: 3,
                    eventId: eventId,
                    data: { ...data, priceData: stepOneResponse?.data?.priceData ?? [] },
                };
                const response = await fetch(API_URLS.SUBMIT_BOOK_EVENT_APPLY_DISCOUNT, {
                    ...fetchDefaults,
                    body: JSON.stringify(request),
                }).then((x) => x.json());
                let { data: dataStageOne } = stepOneResponse ?? { data: undefined };
                if (dataStageOne && response.data?.priceData) {
                    dataStageOne = {
                        ...dataStageOne,
                        priceData: response.data.priceData,
                        totalPrice: response.data.totalPrice,
                        totalPriceDiscounted: response.data.totalPriceDiscounted,
                    };
                }
                // Update step one response with updated price data
                setStepOneResponse({
                    ...stepOneResponse,
                    data: dataStageOne,
                });
                setStepThreeResponse(response);
                break;
            }
        }
        setSubmitting(false);
    };
    return (React.createElement(S.Container, { id: anchorId, spacing: "padding" },
        React.createElement(S.Layout, null,
            React.createElement(S.LeftContent, null,
                React.createElement(S.SectionTitle, null, sectionTitle),
                React.createElement(S.EventType, null, eventLocationType),
                React.createElement(S.Title, null, title),
                React.createElement(S.InPartnershipWith, null, inPartnershipWith),
                React.createElement(S.HR, null),
                React.createElement(S.DetailsList, null,
                    React.createElement(S.Details, null,
                        React.createElement("span", null, "Date"),
                        React.createElement("span", null, date)),
                    React.createElement(S.Details, null,
                        React.createElement("span", null, "Time"),
                        React.createElement("span", null, time)),
                    React.createElement(S.Details, null,
                        React.createElement("span", null, "Venue"),
                        React.createElement("span", null, venue)))),
            alternativeContent ? (React.createElement(S.AlternativeContent, { dangerouslySetInnerHTML: { __html: alternativeContent } })) : (React.createElement(S.FormAccordion, { "data-form-disabled": submitting },
                React.createElement(StepOne, { step: 1, activeStep: activeStep, setActive: (s) => setActiveStep(s), stepProps: {
                        ...bookingForm.stepOne,
                        success: !!confirmationTitle || !!confirmationMessage,
                    }, submit: submit, response: stepOneResponse }),
                React.createElement(StepTwo, { step: 2, activeStep: activeStep, setActive: (s) => setActiveStep(s), stepProps: {
                        ...bookingForm.stepTwo,
                        tickets: bookingForm.stepOne.tickets,
                        attendees: stepOneResponse?.data?.priceData,
                        success: !!confirmationTitle || !!confirmationMessage,
                    }, submit: submit, response: stepTwoResponse }),
                React.createElement(StepThree, { step: 3, activeStep: activeStep, setActive: (s) => setActiveStep(s), submit: submit, stepProps: {
                        ...bookingForm.stepThree,
                        attendees: stepTwoResponse?.data?.attendees,
                        confirmationTitle,
                        confirmationMessage,
                        failureMessages,
                        eventId,
                        code: bookingFormData?.code ?? '',
                    }, response: stepThreeResponse })))),
        submitting && React.createElement(LoadingIndicator, { label: "Submitting\u2026", layout: "fixed" })));
};
export default withQueryParams(withMotion(BookEventForm));
